module.exports = __webpack_public_path__ + "static/partner3-05f827edfc2942526bdf902571a835fa.jpg";